
import { defineComponent } from 'vue'
import LitReviewBuilder from '../LitReviewBuilder.vue'
import ModalManager from '../modals/ModalManager.vue'
import NotificationModal from '../modals/NotificationModal.vue'

export default defineComponent({
  name: 'SingleColumn',
  components: {
    LitReviewBuilder,
    ModalManager,
    NotificationModal
  }
})
